import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import SessionContext from './SessionContext';

function TimeOutPopUp() {
    const { isActive } = useContext(SessionContext);
    const navigate = useNavigate();

    if (!isActive) {
        return (
            <div className='popupBg TimeOutpopupBg' style={{ display: 'block' }}>
                <div className="popUp TimeOutpopUp" style={{ width: "max-content", display: "block" }}>
                    <div className="popup-body">
                        <span>Session Expired. Please Login to Continue</span>
                    </div>
                    <div className="popUp-footer">
                        <button className="Sessionbtn" onClick={() => navigate('/login')}><span>Ok</span></button>
                    </div>
                </div>
            </div>
        );
    }
    return null;
}

export default TimeOutPopUp